import { createGlobalStyle } from 'styled-components';
const font = {
  t300w2: require('./titillium-web-v10-latin-ext_latin-300.woff2'),
  t300w: require('./titillium-web-v10-latin-ext_latin-300.woff'),
  t300iw2: require('./titillium-web-v10-latin-ext_latin-300italic.woff2'),
  t300iw: require('./titillium-web-v10-latin-ext_latin-300italic.woff'),
  t400w2: require('./titillium-web-v10-latin-ext_latin-regular.woff2'),
  t400w: require('./titillium-web-v10-latin-ext_latin-regular.woff'),
  t400iw2: require('./titillium-web-v10-latin-ext_latin-italic.woff2'),
  t400iw: require('./titillium-web-v10-latin-ext_latin-italic.woff'),
  t600w2: require('./titillium-web-v10-latin-ext_latin-600.woff2'),
  t600w: require('./titillium-web-v10-latin-ext_latin-600.woff'),
  t600iw2: require('./titillium-web-v10-latin-ext_latin-600italic.woff2'),
  t600iw: require('./titillium-web-v10-latin-ext_latin-600italic.woff'),
};

export const FontGlobalStyle = createGlobalStyle`

  @font-face {
    font-family: 'Titillium Web';
    font-style: normal;
    font-weight: 300;
    font-display: fallback;
    src: url(${font.t300w2}) format('woff2'), url(${font.t300w}) format('woff');
  }
  @font-face {
    font-family: 'Titillium Web';
    font-style: italic;
    font-weight: 300;
    font-display: fallback;
    src: url(${font.t300iw2}) format('woff2'), url(${font.t300iw}) format('woff');
  }
  @font-face {
    font-family: 'Titillium Web';
    font-style: normal;
    font-weight: 400;
    font-display: fallback;
    src: url(${font.t400w2}) format('woff2'), url(${font.t400w}) format('woff');
  }
  @font-face {
    font-family: 'Titillium Web';
    font-style: italic;
    font-weight: 400;
    font-display: fallback;
    src: url(${font.t400iw2}) format('woff2'), url(${font.t400iw}) format('woff');
  }
  @font-face {
    font-family: 'Titillium Web';
    font-style: normal;
    font-weight: 600;
    font-display: fallback;
    src: url(${font.t600w2}) format('woff2'), url(${font.t600w}) format('woff');
  }
  @font-face {
    font-family: 'Titillium Web';
    font-style: italic;
    font-weight: 600;
    font-display: fallback;
    src: url(${font.t600iw2}) format('woff2'), url(${font.t600iw}) format('woff');
  }
`;
